import { Component, Input } from '@angular/core';

/**
 * Button component
 */
@Component({
  selector: 'def-button',
  templateUrl: './def-button.component.html',
  styleUrls: ['./def-button.component.scss'],
})
export class DefButtonComponent {
  @Input() type?: ('button' | 'submit' | 'file') = 'button';
  @Input() disabled = false;
  @Input() reverse?: boolean;
  @Input() innerWidth?: string;
  @Input() innerHeight?: string;
  @Input() bordered?: boolean;
  @Input() iconName?: string;
  @Input() color?: string;
  @Input() rounded?: boolean = false;
  @Input() iconWhite?: boolean = false;
}
